import styled from 'styled-components';

export const ButtonChildrenWrapper = styled.div`
    padding-left: 4px;
    padding-right: 4px;
`;
